
import { supabase } from '@/integrations/supabase/client';

/**
 * Fetches dashboard data from Supabase storage with fallback handling
 */
export async function fetchDataWithFallback(fileName: string, fallback: any = {}) {
  try {
    // SAST FIX: sanitize fileName to prevent path traversal
    // Allow only alphanumeric characters, dashes, underscores, and dots. 
    // Explicitly reject ".." or "/"
    if (!/^[a-zA-Z0-9.\-_]+$/.test(fileName) || fileName.includes('..') || fileName.includes('/')) {
      console.error(`Invalid filename rejected: ${fileName}`);
      return fallback;
    }

    const response = await supabase.storage.from('dane').download(fileName);
    if (response.error) {
      console.warn(`Failed to load ${fileName}:`, response.error);
      return fallback;
    }

    const text = await response.data.text();

    try {
      const parsedData = JSON.parse(text);
      return parsedData;
    } catch (parseError) {
      console.error(`Error parsing JSON from ${fileName}:`, parseError);
      return fallback;
    }
  } catch (error) {
    console.warn(`Error processing ${fileName}:`, error);
    return fallback;
  }
}

/**
 * Fetches all data sources needed for the dashboard
 */
export async function fetchAllDashboardData(newsFileName: string = 'newsen.json') {

  // Return a promise that fetches all data in parallel
  return Promise.all([
    fetchDataWithFallback('ddos-old.json', { targets: [] }),
    fetchDataWithFallback('leak.json', []),
    fetchDataWithFallback('ransomware.json', []),
    fetchDataWithFallback('2025.json', []),
    fetchDataWithFallback('ddos.json', { targets: [] }),
    // Fetch both news files
    Promise.all([
      fetchDataWithFallback('newsen.json', { items: [] }),
      fetchDataWithFallback('newspl.json', { items: [] })
    ]),
    fetchDataWithFallback('eol.json', {}),
    fetchDataWithFallback('releases.json', []),
  ]);
}
